import { Menu } from '@mantine/core';
import { IconDatabaseImport } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';
import { useNavigate } from 'react-router-dom';

const IngestionsMenuItem = () => {
  const { t } = useTranslate();
  const navigate = useNavigate();

  return (
    <Menu.Item
      leftSection={<IconDatabaseImport stroke={1.5} />}
      onClick={() => navigate('/admin/ingestions')}
    >
      {t('nav.admin.ingestions')}
    </Menu.Item>
  );
};

export default IngestionsMenuItem;
